"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useScrollTrigger.default;
    }
});
var _useScrollTrigger = _interopRequireDefault(require("./useScrollTrigger"));
